"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestObject = void 0;
class IkeRestObject {
    constructor() {
        this.cacheKeys = {
            objectId: true
        };
    }
    canCache(key) {
        return this.cacheKeys[key];
    }
    updateCache(key, result, rest) {
        return;
    }
    cacheIfLatest(key, result, rest) {
        if (result == null) {
            return null;
        }
        const value = result[key];
        const newFetchable = rest.getOne(this, key, value);
        if (newFetchable.hasFetched) {
            if (newFetchable.value == null || newFetchable.value.updatedAt < result.updatedAt) {
                newFetchable.init(result);
            }
        }
        else if (!newFetchable.isFetching) {
            newFetchable.init(result);
        }
    }
}
exports.IkeRestObject = IkeRestObject;
//# sourceMappingURL=base.js.map